<template>
  <el-dialog
    :visible="isProductsModalActive"
    :before-close="beforeClose"
    append-to-body
    fullscreen
    @open="onOpen"
    @close="onClose"
  >
    <div
      class="layout__position-center text__align-center"
    >
      <el-alert
        v-if="errorMessage"
        :title="errorMessage"
        type="error"
        show-icon
        style="position: fixed; top: 0; left: 0; z-index: 2004;"
        @close="$emit('clear-error-message')"
      />

      <h3 class="text__colour-teal mb-20">
        Voucher Products
      </h3>

      <div>
        <el-input
          v-model="searchTerm"
          class="mb-20"
          placeholder="Search by product names or F-codes"
        />

        <div class="d-flex justify-center align-center mb-20">
          Products selected: {{ voucherData.Products ? voucherData.Products.length : 0 }}
          <el-button
            class="ml-10 button__background-red-border button__base"
            :disabled="isLoading"
            @click.prevent="voucherData.Products = []"
          >
            Reset selected
          </el-button>
        </div>

        <div
          v-if="voucherData.Products && voucherData.Products.length"
          class="mb-20 text__align-left"
        >
          <b>Selected product refs: </b> {{ voucherData.Products.join(', ') }}
        </div>

        <el-form
          :model="voucherData"
          class="products-form mb-20"
        >
          <el-form-item prop="Products">
            <el-checkbox-group v-model="voucherData.Products">
              <el-checkbox
                v-show="isShown(product)"
                class="text__direction-left-to-right product-checkbox"
                v-for="product in productsList"
                :key="product.product_ref"
                :label="product.product_ref"
              >
                <b>{{ product.product_ref }}: </b>{{ product.names }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>

        <div
          class="d-flex layout__width-100 justify-center"
        >
          <el-button
            class="button__background-red-border button__base"
            :disabled="isLoading"
            @click.prevent="save"
          >
            Save
          </el-button>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Voucher from '../../../Models/Voucher';

export default {
  name: 'ProductsModal',

  props: {
    isProductsModalActive: {
      type: Boolean,
      required: true,
    },

    editableItem: {
      type: Object | null,
      required: true,
    },

    isLoading: {
      type: Boolean,
      required: true,
    },

    errorMessage: {
      type: String,
      required: false,
      default: '',
    },

    productsList: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      voucherData: {},
      searchTerm: '',
    };
  },

  methods: {
    onOpen() {
      this.voucherData = this.editableItem
        ? Voucher.make({ ...this.editableItem })
        : {};
    },

    onClose() {
      this.searchTerm = '';
    },

    beforeClose() {
      this.$emit('on-closed');
    },

    isShown(product) {
      return product.product_ref.toLowerCase().includes(this.searchTerm.toLowerCase())
        || product.names.toLowerCase().includes(this.searchTerm.toLowerCase());
    },

    save() {
      this.$emit('save-products', this.voucherData);
    },
  },
};
</script>
